import {cssVarsColours} from './variables/colours';
import {cssVarsElementSizing} from './variables/elementSizing';
import {cssVarsFonts} from './variables/fonts';
import {cssVarsSpacing} from './variables/spacing';
import {baseStyles} from './baseStyles';
import {typography} from './typography';

export const injectGlobalStyles = () => {
  // Vars
  cssVarsFonts();
  cssVarsColours();
  cssVarsSpacing();
  cssVarsElementSizing();

  // Base
  baseStyles();
  typography();
};
